import React, { useState, useEffect, useContext, useRef } from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import Cookies from 'js-cookie';
import Swal from 'sweetalert2';

const Content = ({ config, apiURL }) => {
  const [data, setData] = useState([]);
  const [entriesPerPage, setEntriesPerPage] = useState(25);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalEntries, setTotalEntries] = useState(0);
  const [filteredData, setFilteredData] = useState([]);
  const [isLoader, setIsLoader] = useState(true);
  const [sortConfig, setSortConfig] = useState({ key: 'id', direction: 'desc' }); // Ordenación inicial por 'id' descendente

  const [searchTerm, setSearchTerm] = useState('');
  const [countdown, setCountdown] = useState(60);

  const Toast = Swal.mixin({
    toast: true,
    position: "bottom-end",
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.onmouseenter = Swal.stopTimer;
      toast.onmouseleave = Swal.resumeTimer;
      toast.onclick = () => {
        Swal.close();
      };
    }
  });

  const fetchData = async (limit = 25) => {
    try {
      const jwt = Cookies.get('jwt');
      
      const initialResponse = await axios.post(apiURL, {
        type: '/eh/listado',
        option: '/overview',
        limit: limit
      }, { headers: { Authorization: `Bearer ${jwt}` } });
  
      const initialData = initialResponse.data;
  
      if (initialData && initialData.result) {
        setData(initialData.result);
        setFilteredData(initialData.result);
        setTotalEntries(initialData.result.length);

        setIsLoader(false);
  
        const fullResponse = await axios.post(apiURL, {
          type: '/eh/listado',
          option: '/overview'
        }, { headers: { Authorization: `Bearer ${jwt}` } });
  
        const fullData = fullResponse.data;
  
        if (fullData && fullData.result) {
          localStorage.setItem('licenses_key', JSON.stringify(fullData.result));
          Cookies.set('licenses_key', true, { expires: 1 / 24 });

          setData(fullData.result);
          setFilteredData(fullData.result);
          setTotalEntries(fullData.result.length);
        } else {
          console.error(initialData.message);
        }
      } else {
        console.error(initialData.message);
      }
    } catch (error) {
      setData([]);
    }
  };

  useEffect(() => {
    const timingCookie = Cookies.get('licenses_key');
    const ciudadanosData = JSON.parse(localStorage.getItem('licenses_key'));

    if (timingCookie) {
      setData(ciudadanosData);
      setFilteredData(ciudadanosData);
      setTotalEntries(ciudadanosData.length);
      setIsLoader(false);
      setTimeout(() => {
        fetchData(99999);
      }, 1000);

    } else {
      fetchData();
    }

    const intervalId = setInterval(() => {
      setCountdown((prevCountdown) => {
        if (prevCountdown === 1) {
          fetchData(99999999);
          return 60;
        } else {
          return prevCountdown - 1;
        }
      });
    }, 1000);

    return () => clearInterval(intervalId);
  }, []);

  useEffect(() => {
    const sortedData = [...data].sort((a, b) => {
      if (a[sortConfig.key] < b[sortConfig.key]) return sortConfig.direction === 'asc' ? -1 : 1;
      if (a[sortConfig.key] > b[sortConfig.key]) return sortConfig.direction === 'asc' ? 1 : -1;
      return 0;
    });
    setFilteredData(sortedData);
  }, [data, sortConfig]);
  

  const handleEntriesPerPageChange = (e) => {
    setEntriesPerPage(Number(e.target.value));
    setCurrentPage(1);
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
    const filtered = data.filter(item =>
      Object.values(item).some(value =>
        String(value).toLowerCase().includes(e.target.value.toLowerCase())
      )
    );
    setFilteredData(filtered);
    setTotalEntries(filtered.length);
    setCurrentPage(1);
  };

  const handleSort = (key) => {
    let direction = 'asc';
    if (sortConfig.key === key && sortConfig.direction === 'asc') {
      direction = 'desc';
    }
    setSortConfig({ key, direction });
  };

  const indexOfLastEntry = currentPage * entriesPerPage;
  const indexOfFirstEntry = indexOfLastEntry - entriesPerPage;
  const currentEntries = filteredData.slice(indexOfFirstEntry, indexOfLastEntry);

  const totalPages = Math.ceil(totalEntries / entriesPerPage);

  const getPaginationRange = () => {
    const maxVisiblePages = 10;
    const startPage = Math.max(currentPage - Math.floor(maxVisiblePages / 2), 1);
    const endPage = Math.min(startPage + maxVisiblePages - 1, totalPages);
    const adjustedStartPage = Math.max(Math.min(startPage, totalPages - maxVisiblePages + 1), 1);

    return Array.from({ length: endPage - adjustedStartPage + 1 }, (_, i) => adjustedStartPage + i);
  };

  const renderSortIcon = (key) => {
    if (sortConfig.key !== key) {
      return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round">
          <path d="M8 9l4 -4l4 4" /><path d="M16 15l-4 4l-4 -4" />
        </svg>
      );
    } else if (sortConfig.direction === 'asc') {
      return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round">
          <path d="M6 15l6 -6l6 6" />
        </svg>
      );
    } else {
      return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round">
          <path d="M6 9l6 6l6 -6" />
        </svg>
      );
    }
  };
  
  if (isLoader) {
    return (
      <div class="container container-slim py-4">
        <div class="mb-3">
        <a href={`${config.uri}`} class="navbar-brand"><img src={config.logo} height="36" alt={config.name} /></a>
        </div>
        <div class="text-center">
          <div class="text-secondary mb-3">Loading...</div>
          <div class="progress progress-sm">
            <div class="progress-bar progress-bar-indeterminate"></div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="">
        
<table className="table table-vcenter">
  <thead>
    <tr>
      <th>Fecha</th>
      <th>Comentario</th>
      <th>Tecnico</th>
      <th>Desde - Hasta</th>
      <th>HS AL 50%</th>
      <th>HS 100%</th>
    </tr>
  </thead>
  <tbody>

  {currentEntries.map((item, index) => {
    const fecha = typeof item.since === 'string' ? item.since.split(' ') : [];
    const desde = typeof item.desde === 'string' ? item.desde.split(' ') : [];
    const hasta = typeof item.hasta === 'string' ? item.hasta.split(' ') : [];

    return (
        <>
        <tr>
          <td className="w-1">
            {fecha[0]}
          </td>
          <td className="td-truncate">
            <div className="text-truncate">
                {item.tareas}
            </div>
          </td>
          <td className="text-nowrap text-white">{item.tecnico}</td>
          <td className="text-nowrap text-secondary">{desde[1]} - {hasta[1]}</td>
          <td className="text-nowrap text-bold">{item.hsal50 == null ? '-' : item.hsal50}</td>
          <td className="text-nowrap text-bold">{item.hsal100 == null ? '-' : item.hsal100}</td>
        </tr>
        
        </>
    );
  })}

  </tbody>
</table>


    </div>
  );
};

export default Content
